import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=365c41e6&scoped=true&"
import script from "./FullscreenLoader.vue?vue&type=script&lang=ts&"
export * from "./FullscreenLoader.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenLoader.vue?vue&type=style&index=0&id=365c41e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c41e6",
  null
  
)

export default component.exports